import BigNumber from 'bignumber.js';

export const zCurrency = (value: any, currencyUnit: string, showEmptyCurrencyUnit = true, noneChar = '-'): string => {
  if (!value) {
    return `${noneChar}${showEmptyCurrencyUnit ? currencyUnit : ''}`;
  }
  const bigNumberParsedValue = new BigNumber(value).toFormat();
  return bigNumberParsedValue ? `${bigNumberParsedValue}${currencyUnit}` : `${noneChar}${showEmptyCurrencyUnit ? currencyUnit : ''}`;
};
